import { ReactQuery } from '@codeleap/query'
import { QueryKeys } from './queryKeys'
import { create } from './views'

export function useCreate() {
  const createProfile = ReactQuery.useMutation({
    mutationKey: QueryKeys.create.key,
    mutationFn: create,
    onSuccess: () => {
      QueryKeys.me.refresh()
    },
  })

  return {
    createProfile,
  }
}